import JSZip from "jszip";

export function normalizeZipUrl(url) {
  if (url.includes("drive.google.com")) {
    const match = url.match(/\/d\/([^/]+)/);
    if (match) {
      return `https://drive.google.com/uc?export=download&id=${match[1]}&confirm=t`;
    }
  }

  if (url.includes("dropbox.com")) {
    return url
      .replace("www.dropbox.com", "dl.dropboxusercontent.com")
      .replace("?dl=0", "")
      .replace("&dl=0", "");
  }

  return url;
}

export function buildTree(zip) {
  const root = {};
  Object.keys(zip.files).forEach((filePath) => {
    const parts = filePath.split("/").filter(Boolean);
    let current = root;

    parts.forEach((part, idx) => {
      if (!current[part]) {
        current[part] = {
          isFile: idx === parts.length - 1 && !zip.files[filePath].dir,
          path: filePath,
          children: {},
        };
      }
      current = current[part].children;
    });
  });
  return root;
}

export async function loadZipFromBlob(blob) {
  const zip = await JSZip.loadAsync(blob);
  return zip;
}

